import styled from "styled-components";
import { boldFont, regularFont } from "@app/styles";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
`;

export const Backdrop = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const OverLayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 420px;
  max-width: 90%;
  min-height: 236px;
  max-height: 95%;
  position: relative;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 7px;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.25);
`;

export const Title = styled.div`
  font-size: 18px;
  line-height: 22px;
  color: #33403e;
  ${boldFont}
`;

export const MessageContainer = styled.div`
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.035em;
  color: #33403e;
  ${regularFont}
  padding:20px 40px;
  line-height: 25px;
`;
